import { inject, Pipe, PipeTransform } from '@angular/core';
import { B2bService } from '../services/b2b.service';

const FIRST_COLOR = 'red';
const SECOND_COLOR = 'yellow';
const THIRD_COLOR = 'var(--valid-color)';

@Pipe({
	name: 'profitToColor',
})
export class ProfitToColorPipe implements PipeTransform {
	private _b2b = inject(B2bService);
	transform(profitNumber: number, TeudaProfitColor: unknown): string {
		if (typeof TeudaProfitColor !== 'string' || !TeudaProfitColor || TeudaProfitColor === '0' || this._b2b.isB2BAgent$.value) return '';

		const firstNumber = +TeudaProfitColor.split('_')[0];
		const secondNumber = +TeudaProfitColor.split('_')[1];

		if (profitNumber < firstNumber) {
			return FIRST_COLOR;
		}

		if (profitNumber >= firstNumber && profitNumber < secondNumber) {
			return SECOND_COLOR;
		}

		return THIRD_COLOR;
	}

	static hasProfitColor(TeudaProfitColor: string | null): boolean {
		return TeudaProfitColor && TeudaProfitColor !== '0';
	}
}
